// extracted by mini-css-extract-plugin
export default {"tagTitle":"destination-picker_tagTitle__XYcck","icon":"destination-picker_icon__byCd+","tagList":"destination-picker_tagList__2pPGw","tag":"destination-picker_tag__aZlnp"};